import React, { useEffect, useMemo, useState } from "react";
import Icon from "../../../components/Icons/Icon";
import "../../../CSS/Medication.css";
import AddMedication from "./AddMedication";
import FormikController from "../../../components/FormikController/FormikController";
import useSearchData from "../../../components/useSearchData";
import { createColumnDef, useOnGridReady } from "../../../Utils/AgGridUtils";
import SearchBox from "../../../components/Search/SearchBox";
import { useParams } from "react-router-dom";
import { centerStyles, leftStyles } from "../../../Constants/Constants";
import ClientStore from "../../../Store/ClientStore";
import AgencyStore from "../../../Store/AgencyStore";

const MedicationViewPage = () => {
  const { clientId } = useParams();
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState([]);
  const [openEditButton, setOpenEditButton] = useState("save");
  const [medicationList, setMedicationList] = useState(
    ClientStore?.allMedicationList
  );
  const [onGridReady] = useOnGridReady(ClientStore, "safetyAgGrid");
  const handleOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setOpenEditButton("save");
  };
  const [handleSearchChange] = useSearchData();

  const columnDefs = useMemo(
    () => [
      createColumnDef("patientName", "Patient Name", leftStyles, "", "", 90),
      createColumnDef("md", "MD", leftStyles, "", "", 90),
      createColumnDef("pharmacy", "Pharmacy Name", leftStyles, "", "", 90),

      createColumnDef("visitType", "Visit Type", leftStyles, "", "", 70),
      createColumnDef("pharmacyPhoneNo", "Pharmacy No", leftStyles, "", "", 80),
      createColumnDef("mdPhoneNo", "MD No", leftStyles, "", "", 80),
      createColumnDef(
        "manualArtDate",
        "Manual Art Date",
        leftStyles,
        "",
        "",
        80
      ),
      createColumnDef("systemDate", "Update Date", leftStyles, "", "", 80),

      // {
      //   headerName: "Action",
      //   sortable: false,
      //   headerClass: "center-header",
      //   cellStyle: (params) => {
      //     return centerStyles;
      //   },
      //   width: 100,
      //   cellRenderer: (params) => {
      //     const handleEditButton = () => {
      //       setEditData(params.data);
      //       setOpenEditButton("update");
      //       handleOpen();
      //     };
      //     const handleDownloadButton = () => {
      //       // setEditData(params.data);
      //       // openPdf(<CGPOSPdf dataList={params.data} />);
      //     };
      //     return (
      //       <div
      //         style={{
      //           display: "flex",
      //           alignItems: "center",
      //           justifyContent: "center",
      //           gap: "10px",
      //         }}
      //       >
      //         <div className="manageClick" onClick={() => handleEditButton()}>
      //           Edit
      //         </div>
      //         {/* <div
      //           className="docViewText"
      //           onClick={() => handleDownloadButton()}
      //         >
      //           View
      //         </div> */}
      //       </div>
      //     );
      //   },
      // },
    ],
    []
  );

  useEffect(() => {
    if (AgencyStore.isSaveLoading) {
      const fetchData = async () => {
        await ClientStore.getAllMedicationList(clientId);
        setMedicationList(ClientStore?.allMedicationList);
        AgencyStore.setIsSaveLoading(false);
      };
      fetchData();
    }
  }, [AgencyStore.isSaveLoading]);

  return (
    <>
      <div className="homeSafetyWrapper">
        {show ? (
          <AddMedication
            type={openEditButton}
            editData={editData}
            handleClose={handleClose}
            handleOpen={handleOpen}
          />
        ) : (
          <>
            <div className="actionButtonSearchMainContainer">
              <div className="searchMainCotainer">
                <div className="searchContainer">
                  <SearchBox
                    handleChange={(e) => {
                      handleSearchChange(e, "DocList");
                    }}
                  />
                </div>
                <div className="underlineClick" onClick={handleOpen}>
                  <Icon iconName="circleAdd" />
                  Add Medication Records
                </div>
              </div>
            </div>
            <FormikController
              rowData={medicationList}
              control="agGrid"
              columnDefs={columnDefs}
              onGridReady={onGridReady}
            />
          </>
        )}
      </div>
    </>
  );
};

export default MedicationViewPage;
